import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import './Customer.scss';
import { fetchAllCustomers } from '../../api/CustomerApi';

interface Customer {
  id: number;
  name: string;
}

const Customers: React.FC = () => {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadCustomers = async () => {
      try {
        const data = await fetchAllCustomers();
        setCustomers(data);
      } catch (err) {
        setError('Failed to load customers');
      } finally {
        setLoading(false);
      }
    };

    loadCustomers();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <>
      <div className="header-container">
        {/*<LinkButton label="Create Customer" link="/customer"/>* TODO need to add it later */}
      </div>
      <div className="customer-list">
        <ul>
          {customers.map(customer => (
            <li key={customer.id}>
              <Link
                to={`/customer/${customer.id}`}
                className="customer-list-item"
                key={customer.id}>
                {customer.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Customers;
